<template>
  <BlockContainer>
    <div class="transition-opacity" :class="{ 'opacity-0': !story }">
      <ContentArea v-if="!!story">
        <!-- Title -->
        <ContentTitle>{{ story.title }}</ContentTitle>

        <!-- Body -->
        <template v-for="(block, i) in story.body">
          <!-- Text Type -->
          <ContentParagraph v-if="block.blockType === 'text'" :key="i">{{
            block.text
          }}</ContentParagraph>

          <!-- Image Type -->
          <ContentImage
            v-if="block.blockType === 'image'"
            :key="i"
            :images="block.images"
          />

          <!-- Video Type -->
          <ContentVideo
            v-if="block.blockType === 'video'"
            :key="i"
            :video="block.video"
          />
        </template>

        <!-- Footer Area -->
        <div class="col-start-1 col-span-6 flex justify-center my-16 lg:my-0">
          <CoreIcon
            v-for="(icon, i) in icons"
            :key="i"
            :width="isMobile ? 20 : 32"
            :color="icon.color"
            class="mx-1"
          >
            <Component :is="icon.component" />
          </CoreIcon>
        </div>

        <ContentCredits v-bind="story" />
      </ContentArea>
    </div>
  </BlockContainer>
</template>

<script>
import { mapState } from "vuex";
import shuffle from "@utils/shuffle";
import { getBySlug } from "@io/story";
import { BlockContainer } from "@c/Block";
import {
  ContentArea,
  ContentTitle,
  ContentParagraph,
  ContentImage,
  ContentVideo,
  ContentCredits
} from "@c/Content";
import {
  IconStory1,
  IconStory2,
  IconStory3,
  IconStory4,
  IconStory5,
  IconStory6,
  IconStory7,
  IconStory8,
  IconStory9,
  IconStory10,
  IconStory11,
  IconStory12,
  IconStory13,
  IconStory14,
  IconStory15,
  IconStory16,
  IconStory17,
  IconStory18,
  IconStory19,
  IconStory20,
  IconStory21,
  IconStory22,
  IconStory23,
  IconStory24
} from "@c/Icon";

const iconColorKeys = [
  "avo",
  "pink",
  "blue",
  "powder",
  "rust",
  "red",
  "yellow",
  "stone"
];

export default {
  name: "Story",

  meta() {
    return {
      title: this.story ? this.story.title : ""
    };
  },

  components: {
    BlockContainer,
    ContentArea,
    ContentTitle,
    ContentParagraph,
    ContentImage,
    ContentVideo,
    ContentCredits,
    IconStory1,
    IconStory2,
    IconStory3,
    IconStory4,
    IconStory5,
    IconStory6,
    IconStory7,
    IconStory8,
    IconStory9,
    IconStory10,
    IconStory11,
    IconStory12,
    IconStory13,
    IconStory14,
    IconStory15,
    IconStory16,
    IconStory17,
    IconStory18,
    IconStory19,
    IconStory20,
    IconStory21,
    IconStory22,
    IconStory23,
    IconStory24
  },

  data: () => ({
    story: null
  }),

  computed: {
    ...mapState({
      isMobile: state => state.ui.isMobile
    }),
    icons() {
      const icons = [
        "IconStory1",
        "IconStory2",
        "IconStory3",
        "IconStory4",
        "IconStory5",
        "IconStory6",
        "IconStory7",
        "IconStory8",
        "IconStory9",
        "IconStory10",
        "IconStory11",
        "IconStory12",
        "IconStory13",
        "IconStory14",
        "IconStory15",
        "IconStory16",
        "IconStory17",
        "IconStory18",
        "IconStory19",
        "IconStory20",
        "IconStory21",
        "IconStory22",
        "IconStory23",
        "IconStory24"
      ];

      shuffle(icons);

      const iconState = icons.map(icon => ({
        component: icon,
        color: this.randomColor()
      }));

      return iconState.slice(0, 4);
    }
  },

  async created() {
    const story = await getBySlug(this.$route.params.slug);
    // If null redirenct to 404
    if (story === null) {
      this.$router.push({ name: "404" });
      return;
    }

    this.story = Object.values(story)[0];
  },

  methods: {
    randomColor() {
      const index = Math.floor(
        Math.random() * Math.floor(iconColorKeys.length)
      );
      return iconColorKeys[index];
    }
  }
};
</script>
